module.exports = __webpack_public_path__ + "img/basic_img.c0e0ab24.png";